<p-toast position="top-right" key="save"></p-toast>
<div class="bg-default px-3 pb-3">
  <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
    <div class="conten">
      <div class="btn"><a> Facility-PI</a></div>
    </div>
  </div>

  <div class="bg-default">
    <div class="grid justify-content-end mb-2">
      <!-- Search Filters start -->
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b>Filter Type</b></label>
        <p-dropdown [options]="roleForFacility ? selectedFacilityOptions.slice(0, 4) : selectedFacilityOptions" [(ngModel)]="facility" (onChange)="onChangeFilterType($event)"
          optionLabel="name" optionValue="value" class="mr-2"></p-dropdown>
      </div>
      <!-- <div class="col-12 md:col-6 lg:col-2" *ngIf="selectFacilityPIOptionsBool == true">
        <label *ngIf="facilityQPSLbl == 1"><b
            [ngStyle]="filterType && facilityQPSLbl == 1 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Facility</b></label>
        <label *ngIf="facilityQPSLbl == 2"><b
            [ngStyle]="filterType && facilityQPSLbl == 2 ? {'color':'red','font-size':'15px'} : {'color':'black'}">System</b></label>
        <label *ngIf="facilityQPSLbl == 3"><b
            [ngStyle]="filterType && facilityQPSLbl == 3 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Region</b></label>
        <label *ngIf="facilityQPSLbl == 4"><b
            [ngStyle]="filterType && facilityQPSLbl == 4 ? {'color':'red','font-size':'15px'} : {'color':'black'}">State</b></label>
        <label *ngIf="facilityQPSLbl == 5"><b
            [ngStyle]="filterType && facilityQPSLbl == 5 ? {'color':'red','font-size':'15px'} : {'color':'black'}">QPS</b></label>
        <label *ngIf="facilityQPSLbl == 6"><b
            [ngStyle]="filterType && facilityQPSLbl == 6 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Filter
            Type</b></label>
        <p-dropdown [options]="SelectListFilter" [(ngModel)]="selectFacilityPIOptions" optionLabel="Text"
          [filter]="true" filterBy="Text" placeholder="-- Select --" optionValue="Value" class="mr-2"></p-dropdown>
      </div> -->
      <div class="col-12 md:col-6 lg:col-2" *ngIf="selectFacilityPIOptionsBool">
        <ng-container *ngFor="let label of facilityLabels; let i = index">
          <label *ngIf="facilityQPSLbl === i + 1" [ngStyle]="getStyle(i + 1)"><b>{{ label }}</b></label>
        </ng-container>
        <p-dropdown [options]="SelectListFilter" [(ngModel)]="selectFacilityPIOptions" optionLabel="Text"
          [filter]="true" filterBy="Text" placeholder="-- Select --" optionValue="Value" class="mr-2"></p-dropdown>
      </div>
      
      <div class="col-12 md:col-6 lg:col-2" *ngIf="activeOptionsBool == false">
        <label for="FirstName"><b>Active/InActive</b></label>
        <p-dropdown [options]="selectActiveOptions" [(ngModel)]="active" optionLabel="name" optionValue="value"
          class="mr-2"></p-dropdown>
      </div>
      <!-- Newly Added Pre-Arrival -->
      <div class="col-12 md:col-6 lg:col-2" *ngIf="pre_ArrivalBool == true">
        <label for="Pre_Arrival"><b>Pre-Arrival</b></label>
        <p-dropdown [options]="preArivalOptions" [(ngModel)]="pre_arival" optionLabel="Text" optionValue="Value"
          class="mr-2"></p-dropdown>
      </div>
      <!-- Newly Added WorkFlow Type -->
      <!-- Without option = "All"  -->
      <div class="col-12 md:col-6 lg:col-2" *ngIf="workFlowPiTrendTypeBool == true">
        <label for="WorklowType"><b
            [ngStyle]="workFlowTypeColorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">WorkFlow
            Type</b></label>
        <span class="p-input-icon-right w-full">
          <p-multiSelect class="multiselect-custom mr-2" [options]="selectWorkFlowTypeOptions"
            [style]="{'Width':'100%'}" [panelStyle]="{'width':'100%'}" placeholder="--Select--"
            defaultLabel="--Select--" display="chip" [(ngModel)]="work_flow_piTrend" optionLabel="Text"
            optionValue="Value"> </p-multiSelect>
        </span>
      </div>

      <!-- Newly Added Spoke Side -->
      <div class="col-12 md:col-6 lg:col-2" *ngIf="spokeSiteBool == true">
        <label for="FirstName"><b>Spoke Site</b></label>
        <p-dropdown [options]="spokeSiteOpions" [(ngModel)]="spokeSite" optionLabel="Text" optionValue="Value"
          class="mr-2"></p-dropdown>
      </div>
      <div class="col-12 md:col-6 lg:col-2">
        <label for="FirstName"><b
            [ngStyle]="reportTypeError ? {'color':'red','font-size':'15px'} : {'color':'black'}">Report
            Type</b></label>
        <p-dropdown [options]="selectReportTypeOptions" [(ngModel)]="reportType" (onChange)="onChangeReportType($event)"
          optionLabel="name" optionValue="value" class="mr-2"></p-dropdown>
      </div>

      <div class="col-12 md:col-6 lg:col-3" *ngIf="fromDaysToDaysBool == true">
        <label for="FirstName"><b
            [ngStyle]="fromDateErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">From
            Date</b></label>
        <p-calendar [(ngModel)]="fromMonth" (onSelect)="CheckDaysDate($event)" placeholder="From Days" [showIcon]="true"
          inputId="icon" class="mr-2">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-3" *ngIf="fromDaysToDaysBool == true">
        <label for="FirstName"><b
            [ngStyle]="toDateErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">To Date</b></label>
        <p-calendar [(ngModel)]="toMonth" (onSelect)="CheckDaysDate($event)" placeholder="To Days" [showIcon]="true"
          inputId="icon" class="mr-2">
        </p-calendar>

      </div>
      <div class="col-12 md:col-6 lg:col-3" *ngIf="monthBool == true;">
        <label for="FirstName"><b
            [ngStyle]="fromMonthErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">From
            Month</b></label>
        <p-calendar placeholder="From Month" [(ngModel)]="fromMonthAndComulative" view="month" dateFormat="mm/yy"
          [showIcon]="true" inputId="icon" [defaultDate]="fromMonthAndComulative" class="mr-2"></p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-3" *ngIf="monthBool == true;">
        <label for="FirstName"><b
            [ngStyle]="toMonthErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">To Month</b></label>
        <p-calendar placeholder="To Month" (click)="enableSearch($event)" [(ngModel)]="toMonthAndComulative"
          [defaultDate]="toMonthAndComulative" view="month" [showIcon]="true" inputId="icon" class="mr-2"
          dateFormat="mm/yy">
        </p-calendar>
      </div>
      <div class="col-12 md:col-6 lg:col-2" *ngIf="selectWeekBool == true">
        <label for="FirstName"><b
            [ngStyle]="weekErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Select Week</b></label>
        <p-calendar placeholder="Select Week" [(ngModel)]="fromMonth" [disabledDays]="[1,2,3,4,5,6]"
          [readonlyInput]="true" [showIcon]="true" inputId="icon" class="mr-2"></p-calendar>
      </div>
    </div>
    <!-- Search Filters SelectEnd -->
    <div class="mb-2" id="search_chart_excel_btn">
      <!-- Search and Export button start -->
      <p-button label=" Export to Excel" *ngIf="excel_chartDisabe.excel_show" icon="pi pi-upload"
        (click)="exportExcel()" [loading]="exportExcelLoader"
        [ngStyle]="excel_chartDisabe.value?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
        [disabled]="excel_chartDisabe.value" class="p-button-primary mr-2"></p-button>
      <p-button label=" FacilityDashboard Charts" *ngIf="excel_chartDisabe.facility_charts_Show" icon="pi pi-chart-line"
        (click)="getAllPieChartsData();getFacilityDashboardAllCharts();"
        [ngStyle]="excel_chartDisabe.value?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
        [loading]="FacilityDashboardLoader" [disabled]="excel_chartDisabe.value" class="p-button-primary mr-2">
      </p-button>
      <p-button label="Pie Chart" *ngIf="excel_chartDisabe.pi_chart_show" icon="pi pi-chart-pie" (click)="getPiChart()"
        [loading]="pi_chartBool"
        [ngStyle]="excel_chartDisabe.value?{'pointer-events': 'none'} : {'pointer-events': 'all'}"
        [loading]="piChartLoader" [disabled]="excel_chartDisabe.value" class="p-button-primary mr-2"></p-button>
      <p-button label="Search" icon="pi pi-search" [loading]="loader.value" (click)="getFacilityDashboardValues()"
        class="p-button-primary mr-2" [disabled]="onClickSearchBtnDisable"
        [ngStyle]="onClickSearchBtnDisable?{'pointer-events': 'none'} : {'pointer-events': 'all'}"></p-button>
    </div>
    <!-- Search and Export button end -->
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 facilitypi-btn mb-3 px-4">

        <a class="no-underline" href="Home/Analyze/Facility-PI" target="_blank">
          <p-button type="button" class="p-button-primary mr-1" [id]="btnClicked == 1 ? 'Bpink': ''"
            (click)="facilitySelectedTab = 'Facility Dashboard'; filterSelection(); onContextMenu($event)"
            label="Facility Dashboard"></p-button>
        </a>
        <a class="no-underline" href="Home/Analyze/Facility-PI" target="_blank">
          <p-button type="button" [id]="btnClicked == 2 ? 'Bpink': ''"
            (click)="facilitySelectedTab = 'RAPIDi Notification';filterSelection();onContextMenu($event)"
            label="RAPIDi Case Reports" class="p-button-primary mr-1"></p-button>
        </a>
        <a class="no-underline" href="Home/Analyze/Facility-PI" target="_blank">
          <p-button type="button" [id]="btnClicked == 3 ? 'Bpink': ''"
            (click)="facilitySelectedTab = 'TPA Case Analysis';filterSelection(); onContextMenu($event)"
            label="Thrombolytic Case Analysis" class="p-button-primary mr-1"></p-button>
        </a>
        <a class="no-underline" href="Home/Analyze/Facility-PI" target="_blank">
          <p-button type="button" [id]="btnClicked == 4 ? 'Bpink': ''"
            (click)="facilitySelectedTab = 'PI Trends';filterSelection(); onContextMenu($event)" label="PI Trends"
            class="p-button-primary mr-1">
          </p-button>
        </a>
        <a class="no-underline" href="Home/Analyze/Facility-PI" target="_blank">
          <p-button type="button" [id]="btnClicked == 5 ? 'Bpink': ''"
            (click)="facilitySelectedTab = 'Counter Measures';filterSelection(); onContextMenu($event)"
            label="Counter Measures" class="p-button-primary mr-1"></p-button>
        </a>
        <a class="no-underline" href="Home/Analyze/Facility-PI" target="_blank">
          <p-button type="button" [id]="btnClicked == 6 ? 'Bpink': ''"
            (click)="facilitySelectedTab = 'Volumetrics';filterSelection(); onContextMenu($event)" label="Volumetrics"
            class="p-button-primary mr-1"></p-button>
        </a>
        <a class="no-underline" href="Home/Analyze/Facility-PI" target="_blank">
          <p-button type="button" [id]="btnClicked == 7 ? 'Bpink': ''"
            (click)="facilitySelectedTab = 'Stroke Alert Cases';filterSelection(); onContextMenu($event)"
            label="Stroke Alert Cases" class="p-button-primary mr-1"></p-button>
        </a>
      </div>
      <!-- Tabs Button end -->
    </div>

    <!-- -------------------------------Facility Tab Components Render----------------------------------- -->
    <ng-container *ngIf="facilitySelectedTab == 'Facility Dashboard'">
      <app-facility-dashboard></app-facility-dashboard>
    </ng-container>
    <ng-container *ngIf="facilitySelectedTab == 'RAPIDi Notification'">
      <app-rapidi-notification></app-rapidi-notification>
    </ng-container>
    <ng-container *ngIf="facilitySelectedTab == 'TPA Case Analysis'">
      <app-tpa-case-analysis></app-tpa-case-analysis>
    </ng-container>
    <ng-container *ngIf="facilitySelectedTab == 'PI Trends'">
      <app-pi-trends></app-pi-trends>
    </ng-container>
    <ng-container *ngIf="facilitySelectedTab == 'Counter Measures'">
      <app-counter-measures></app-counter-measures>
    </ng-container>
    <ng-container *ngIf="facilitySelectedTab == 'Volumetrics'">
      <app-volumetrics></app-volumetrics>
    </ng-container>
    <ng-container *ngIf="facilitySelectedTab == 'Stroke Alert Cases'">
      <app-stroke-alert-cases></app-stroke-alert-cases>
    </ng-container>
    <!-- ---------------Diaglog For Chart---------------------- -->

    <p-dialog [(visible)]="allChartBool" [breakpoints]="{'960px': '75vw'}" [draggable]="false" [style]="{width: '75%'}"
      [modal]="true" styleClass="p-fluid">
      <ng-template pTemplate="header">
        <span>
          <p-button *ngIf="!chartFoundBool" type="button" icon="pi pi-file-pdf" (click)="exportPdf()"
            [loading]="exportPdfFacilityDashboardLoader" label="Save as PDF" class="p-button-primary mr-1 save-facilitymodal"></p-button>
        </span>
      </ng-template>
      <ng-template pTemplate="content">
        <p-toast position="top-right"></p-toast>
        <div class="chart-popup" id="htmlData" #htmlData *ngIf="!chartFoundBool">
          
          <!-- Stroke Alert Chart -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <span class="piechart-header">
                      <p class="pie-text">Stroke Alert Chart, {{minDateSelectedStrokeAlert}} - {{maxDateSelectedStrokeAlert}}</p>
                  </span>
                  <span class="piechart-header">
                    <p class="text-center pie-text">Total Cases - {{TotaAllSelectedDateStrokeAlert}}</p>
                  </span>
                    <kendo-chart title="" class="kendoChart" *ngIf="!selectedDateStrokeAlertBool">
                      <kendo-chart-legend position="bottom"></kendo-chart-legend>
                      <kendo-chart-series>
                        <kendo-chart-series-item type="pie" [data]="pieDataSelectedDateStrokeAlert" field="value" categoryField="category"
                        colorField="colorField" [labels]="{ visible: true, content: labelContent, visual: visualContent }">
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                    <h1 *ngIf="selectedDateStrokeAlertBool" class="text-center">No Record Found</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Volumetric Chart -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <span class="piechart-header QMSALLCHARTS">
                      <p class="pie-text">Volumetric Chart, {{minDateSelectedVolumetric}} - {{maxDateSelectedVolumetric}}</p>
                  </span>
                  <span class="piechart-header">
                    <p class="text-center pie-text">Total Cases - {{TotaAllCasesSelectedVolimatric}}</p>
                  </span>
                    <kendo-chart title="" class="kendoChart" *ngIf="!selectedDateVolumetricBool">
                      <kendo-chart-legend position="bottom"></kendo-chart-legend>
                      <kendo-chart-series>
                        <kendo-chart-series-item type="pie" [data]="pieDataSelectedVolimatric" field="value" categoryField="category"
                        colorField="colorField" [labels]="{ visible: true, content: labelContent, visual: visualContent }">
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                    <h1 *ngIf="selectedDateVolumetricBool" class="text-center">No Record Found</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Volumetric Chart from to -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <span class="piechart-header QMSALLCHARTS">
                      <p class="pie-text">Volumetric Chart, {{minDateFirstMonthVolumetric}} - {{maxDateFirstMonthVolumetric}}</p>
                  </span>
                  <span class="piechart-header">
                    <p class="text-center pie-text">Total Cases - {{TotaAllFirstMonthDateVolumetric}}</p>
                  </span>
                    <kendo-chart title="" class="kendoChart" *ngIf="!firstMonthDateVolumetricBool">
                      <kendo-chart-legend position="bottom"></kendo-chart-legend>
                      <kendo-chart-series>
                        <kendo-chart-series-item type="pie" [data]="firstMonthDateVolumetric" field="value" categoryField="category"
                        colorField="colorField" [labels]="{ visible: true, content: labelContent, visual: visualContent }">
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                    <h1 *ngIf="firstMonthDateVolumetricBool" class="text-center">No Record Found</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Door to Notification Mean (minutes : seconds) -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="Door to Notification Mean and Median (Min:Sec)" color="black"
                        [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif'}">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="doortostartcatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels" [min]="minDoortostartVal" [max]="maxDoortostartVal + 80000">
                          <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                            color="#000000">
                          </kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="doortostartmeancal" [spacing]="0.25" [gap]="1" type="line" smooth="true"
                          [style]="style" [color]="series.color" name="Mean" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [margin]="{ bottom: calculateLengthForMarginLabel() }" [content]="doortostartMeanChartContent"
                            [color]="series.color" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item [data]="doortostartmediancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="seriesMedian.color" name="Median" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [content]="doortostartMedianChartContent" [color]="seriesMedian.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- % 10 Min or Less Acivation EMS, Triage & Inpatient -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="% 10 Min or Less Activation EMS & Triage" color="black"
                        [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif'}">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="activationemscatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels">
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item name="EMS" [data]="activationemsmeancal" [spacing]="0.25" [gap]="1"
                          [labels]="seriesLabels" [color]="series.color" smooth="true" [style]="style">
                          <kendo-chart-series-item-labels [color]="series.colorLabel" [font]="series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item name="Triage/PV" [data]="activationpvmeancal" [spacing]="0.25" [gap]="1"
                          [labels]="seriesLabels" [color]="seriesMedian.color" smooth="true" [style]="style">
                          <kendo-chart-series-item-labels [color]="seriesMedian.colorLabel" [font]="series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Activation to Assessment Mean and Median -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="Activation to Assessment Mean and Median (Min:Sec)" color="black"
                        [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="ActivationtoAssessmentcatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels" [min]="minActivationtoAssessmentVal"  [max]="maxActivationtoAssessmentVal + 80000">
                          <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                            color="#000000">
                          </kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="ActivationtoAssessmentmeancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="series.color" name="Mean" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [margin]="{ bottom: calculateLengthForMarginLabel() }"
                            [content]="ActivationtoAssessmentMeanChartContent" [color]="series.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item [data]="ActivationtoAssessmentmediancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="seriesMedian.color" name="Median" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [content]="ActivationtoAssessmentMedianChartContent" [color]="seriesMedian.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- TS Notification To Initial Response Mean and Median  -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="TS Notification to Initial Response Mean and Median (Min:Sec)"
                        color="black" [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="starttoresponsecatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels" [min]="minStarttoresponseVal" [max]="maxStarttoresponseVal + 80000">
                          <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                            color="#000000">
                          </kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="starttoresponsemeancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="series.color" name="Mean" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [margin]="{ bottom: calculateLengthForMarginLabel() }"
                            [content]="TS_Notification_to_Initial_ResponseMeanChartContent" [color]="series.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item [data]="starttoresponsemediancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="seriesMedian.color" name="Median" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [content]="TS_Notification_to_Initial_ResponseMedianChartContent" [color]="seriesMedian.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Assessment To Thrombolytic Decision -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="Assessment To Thrombolytic Decision Making Mean and Median (Min:Sec)"
                        color="black" [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="AssessmenttoThrombolyticcatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels" [min]="minAssessmenttoThrombolyticval" [max]="maxAssessmenttoThrombolyticval + 80000">
                          <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                            color="#000000">
                          </kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="AssessmenttoThrombolyticmeancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="series.color" name="Mean" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [margin]="{ bottom: calculateLengthForMarginLabel() }"
                            [content]="Assessment_to_Thrombolytic_DecisionMeanChartContent" [color]="series.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item [data]="AssessmenttoThrombolyticmediancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="seriesMedian.color" name="Median" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [content]="Assessment_to_Thrombolytic_DecisionMedianChartContent" [color]="seriesMedian.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Thrombolytic Decision Making To Admin  -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title
                        text="Thrombolytic Medical Decision to Thrombolytic Administration Mean and Median (Min:Sec)"
                        color="black" [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif'}">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="ThrombolytictoThrombolyticadministrationcatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels"
                          [min]="minThrombolytictoThrombolyticadministrationVal" [max]="maxThrombolytictoThrombolyticadministrationVal + 80000">
                          <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                            color="#000000">
                          </kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="ThrombolytictoThrombolyticadministrationmeancal" [spacing]="0.25"
                          [gap]="1" type="line" smooth="true" [style]="style" [color]="series.color" [size]="50" name="Mean"
                          [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [margin]="{ bottom: calculateLengthForMarginLabel() }"
                            [content]="Thrombolytic_Decision_Making_to_AdminMeanChartContent" [color]="series.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item [data]="ThrombolytictoThrombolyticadministrationmediancal" [spacing]="0.25"
                          [gap]="1" type="line" smooth="true" [style]="style" [color]="seriesMedian.color" name="Median"
                          [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [content]="Thrombolytic_Decision_Making_to_AdminMedianChartContent" [color]="seriesMedian.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <!-- DTN equal to or less than 30 Minutes, 45 minutes and 60 minutes (%) -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="DTN equal to or less than 30 minutes, 45 minutes and 60 minutes (%)" color="black"
                        [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="DTN30percentcatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels">
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item name="(30)Min" [data]="DTN30percentmeancal" [spacing]="0.25" [gap]="1"
                          [labels]="seriesLabels" smooth="true">
                          <kendo-chart-series-item-labels [background]="'transparent'" [color]="series.colorLabel"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item name="(45)Min" [data]="DTN45percentmeancal" [spacing]="0.25" [gap]="1"
                          [labels]="seriesLabels" smooth="true">
                          <kendo-chart-series-item-labels [background]="'transparent'" [margin]="{ bottom: 15 }"
                            [color]="seriesMedian.colorLabel" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item name="(60)Min" [data]="DTN60percentmeancal" [spacing]="0.25" [gap]="1"
                          [labels]="seriesLabels" smooth="true">
                          <kendo-chart-series-item-labels [background]="'transparent'" [margin]="{ bottom: 30 }"
                            [color]="seriesdtn60.colorLabel" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <!-- THROMBOLYTIC ADMINISTERED # -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="Number of Thrombolytic Administered" color="black"
                        [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="alteplaseadmincatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels">
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="alteplaseadminmeancal" [spacing]="0.25" [gap]="1"
                          name="Thrombolytic Administered" [color]="series.color" smooth="true" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [color]="series.colorLabel" [font]="series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Door To Needle Mean and Median (Min:Sec) -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="Door To Needle Mean and Median (Min:Sec)" color="black"
                        [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="doortoneedlecatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels" [min]="minDoortoneedleVal"
                          [max]="maxDoortoneedleVal + 80000">
                          <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif" color="#000000">
                          </kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="doortoneedlemeancal" [spacing]="0.25" [gap]="1" type="line" smooth="true"
                          [style]="style" [color]="series.color" name="Mean" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [margin]="{ bottom: calculateLengthForMarginLabel() }" [content]="Door_to_NeedleMeanChartContent"
                            [color]="series.color" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item [data]="doortoneedlemediancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="seriesMedian.color" name="Median" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [content]="Door_to_NeedleMedianChartContent" [color]="seriesMedian.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- Activation To Needle -->
          <div class="grid">
            <div class="col-12 relative">
              <div class="page firstPageBorderTop mt-2 improveReport" size="A4">
                <div class="pt-2 pl-2 pr-2 pb-2">
                  <div>
                    <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
                      <kendo-chart-title text="Activation To Needle Mean and Median (Min:Sec)" color="black"
                        [font]="screenWidth < 1500 ? 'bold 17px Arial, sans-serif' : 'bold 20px Arial, sans-serif'"
                        [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
                      </kendo-chart-title>
          
                      <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
                      </kendo-chart-legend>
          
                      <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="activitationtoneedlecatgory">
                          <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black" rotation="auto">
                          </kendo-chart-category-axis-item-labels>
                        </kendo-chart-category-axis-item>
                      </kendo-chart-category-axis>
          
                      <kendo-chart-value-axis>
                        <kendo-chart-value-axis-item [labels]="valueAxisLabels" [min]="minActivitationtoneedleVal" [max]="maxActivitationtoneedleVal + 80000">
                          <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                            color="#000000">
                          </kendo-chart-value-axis-item-labels>
                        </kendo-chart-value-axis-item>
                      </kendo-chart-value-axis>
          
                      <kendo-chart-series>
                        <kendo-chart-series-item [data]="activitationtoneedlemeancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="series.color" name="Mean" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [margin]="{ bottom: calculateLengthForMarginLabel() }"
                            [content]="Activation_to_NeedleMeanChartContent" [color]="series.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                        <kendo-chart-series-item [data]="activitationtoneedlemediancal" [spacing]="0.25" [gap]="1" type="line"
                          smooth="true" [style]="style" [color]="seriesMedian.color" name="Median" [labels]="seriesLabels">
                          <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                            [content]="Activation_to_NeedleMedianChartContent" [color]="seriesMedian.color"
                            [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                          </kendo-chart-series-item-labels>
                        </kendo-chart-series-item>
                      </kendo-chart-series>
                    </kendo-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="chart-popup bg-default" *ngIf="chartFoundBool">
          <h4 class="text-center create-roles w-full"><b> No Data Available For Graphs </b></h4>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton type="button" *ngIf="!chartFoundBool" (click)="hideChartDiaglog()" class=" btn-UnCancelCase">
          <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
      </ng-template>
    </p-dialog>
  </div>